//全局注册组件
//左侧一级导航
// import Nav from '@/components/Nav.vue';
// 完成订单备注
import Remark from '@/components/remark.vue';

//数组存放接收的组件名
const components = [
  // { name: "Nav", con: Nav },
  { name: "Remark", con: Remark }
]
//循环注册组件
const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component.con);
  });
};

export default {
  install
};
